import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import { ContinueWithBackButtons } from 'components/base/BottomStepComponent';
import {
  defaultPreviewImage,
  getPreviewLayoutImages,
} from 'components/campaign/campaignCreation/CampaignStepTwoPreviewConfig';
import { validate } from 'containers/engagement/campaign/CreateCampaignValidate';

import './CreateCampaignStepTwo.scss';
import { scrollToFirstError } from './CreateCampaignHandleError';
import { CREATION_STEP_TWO_CONFIG } from 'containers/engagement/campaign/CampaignCreationConfig';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';

function CreateCampaignStepTwoV2({ languages }) {
  const {
    getValues,
    watch,
    formState: { errors },
    clearErrors,
    setError,
  } = useFormContext();
  const {
    extraValidate,
  } = CREATION_STEP_TWO_CONFIG

  const errorLanguage = Object.keys(errors?.translations || [])?.[0];
  const watchCampaignType = watch('campaignType');
  const dispatch = useDispatch();
  const defaultImage = defaultPreviewImage(watchCampaignType);

  const [fieldError, setFieldError] = useState(Object.keys(errors || []).length);
  const inputWithImageConfig = getPreviewLayoutImages(watchCampaignType);
  useEffect(() => {
    setFieldError(Object.keys(errors || []).length);
    scrollToFirstError(
      errors,
      [
        "translations.en.generalName",
        "translations.en.coverPhoto",
        "translations.en.squareCoverPhoto",
      ]
    )
  }, [errors]);

  const stepChangeAction = (isBack) => {
    setFieldError(0);
    let isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 1,
      isBack,
      languages: languages?.map(item => item.code),
    });
    if (extraValidate) {
      isValid = extraValidate({
        getValues,
        setError,
        clearErrors
      }) && isValid
    }
    dispatch({
      type: 'createCampaign/stepChange',
      payload: { isBack: isBack, step: 1, isValid },
    });
  };

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATION_STEP_TWO_CONFIG}
        hidePreview={false}
        fieldsError={fieldError}
        errorLanguage={errorLanguage}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultImage}
      />
      <ContinueWithBackButtons
        continueAction={() => {
          stepChangeAction(false);
        }}
        backAction={() => {
          stepChangeAction(true);
        }}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  languages: state.language.allList,
});

export default connect(mapPropsToState)(CreateCampaignStepTwoV2);
